import styled from 'styled-components';

export const InfoWorkerModalStyle = styled.div`
  position: relative;
  transition: all ease 0.8s;
  width: 100%;
  height: 100vh;
  height: inherit;
  justify-content: center;
  align-items: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .centered-content {
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  > .modal {
    z-index: 6000;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 2rem);
    width: 67rem;
    background-color: var(--board);
    border-radius: 0.5rem;
    overflow: hidden;
    @media screen and (max-width: 1024px) {
      /* width: 80%; */
      width: calc(100vw - 2rem);
    }
    @media screen and (max-width: 767px) {
      width: 100%;
      height: 100vh;
      height: inherit;
      overflow-y: auto;
      border-radius: 0;
    }
    > .inputForm-head {
      position: relative;
      font-weight: 500;
      flex-shrink: 0;
      padding: 0.5rem 0.5rem;
      border-bottom: 1px solid var(--outline);
      .modalHeaderCenter {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: var(--text-primary);
      }
      > svg {
        width: 24px;
        height: 24px;
      }
      .closeBtn {
        width: 2rem;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5rem;
        cursor: pointer;
        margin: 0 0.5rem;
        color: var(--text-primary);
      }
      .closeBtn:hover {
        background-color: var(--tonal);
      }
      .material-symbols-rounded {
        color: var(--text-primary);
        font-variation-settings: 'FILL' 1, 'wght' 500, 'GRAD' 0, 'opsz' 20;
      }
      .arrow-icon span {
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .icon-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        gap: 0.25rem;
        cursor: pointer;
        border-radius: 5rem;
        padding-right: 1rem;
        padding-left: 0.5rem;
        font-size: 0.875rem;
        background-color: var(--tonal);
        color: var(--text-primary);
      }
      .icon-btn:hover {
        background-color: var(--tonal-deep);
      }
    }
    > .inputForm-body {
      flex-shrink: 1;
      background-color: var(--board);
      color: #121212;
      overflow-y: initial;
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow-y: auto;

      .modal-contents-container {
        background-color: var(--board);
        flex-grow: 1;
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        .subHead {
          padding: 2rem 0;
        }
      }
      .modal-contents {
        background-color: var(--board);
        padding: 1rem;
        flex-grow: 1;
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        .subHead {
          padding: 2rem 0;
        }
        @media (min-width: 1080px) {
          overflow-x: hidden;
        }
        @media (min-width: 640px) {
          // padding: 1.5rem;
        }
        &.noPadding {
          padding: 0 0.75rem;
          @media (min-width: 640px) {
            padding: 0;
            overflow: hidden;
            > div {
              height: 100%;
              display: flex;
              flex-direction: column;
              > .searchOption {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                overflow: hidden;
              }
            }
          }
        }
      }
      .inputFormText {
        line-height: 1.5;
        border-radius: 5px;
        padding: 1rem;
        background-color: rgba(18, 97, 255, 0.1);
        margin-bottom: 2rem;
        letter-spacing: -0.07rem;
      }
      .content {
        padding-top: 1rem;
        background-color: transparent;
      }

      .flexStart {
        justify-content: flex-start;
        > label {
          min-width: 8rem;
        }
      }

      .labelRow {
        > div > div {
          display: flex;
          > label {
            min-width: 8rem;
          }
        }
      }

      .paddingBottom {
        padding-bottom: 2rem;
      }

      label {
        display: flex;
        align-items: center;
      }
    }
    > .inputForm-body.attendList {
      overflow: hidden;
      > div:first-child {
        overflow: auto;
        flex-grow: 1;
        width: 100%;
        overflow: hidden;

        > .modalRibbon {
          width: 100%;
          padding: 0.5rem 0.75rem;
          position: sticky;
          left: 0;
          display: flex;
          align-items: center;
          flex-direction: row;
          justify-content: space-between;
          gap: 2rem;
          touch-action: none;
          @media (max-width: 767px) {
            .mobileOptimizedAttendList & {
              flex-direction: column;
              gap: 0.5rem;
              align-items: stretch;
            }
          }
          > div:first-child {
            padding: 0.25rem 0.75rem;
            border-radius: 0.25rem;
            flex-grow: 1;
            height: 2.5rem;
            display: flex;
            align-items: center;
            background-color: var(--tonal-light);
            /* outline: 1px solid var(--outline); */
            @media (max-width: 767px) {
              .mobileOptimizedAttendList & {
                width: 100%;
              }
            }
            > span {
              font-size: 0.875rem;
              color: var(--text-secondary);
              > span {
                color: var(--text-primary);
                font-weight: 500;
                margin-left: 0.5rem;
              }
            }
            > span:nth-child(2)::before {
              content: '•';
              margin: 0 0.25rem;
            }
            /* 띠 우측 끝 바로가기 버튼 (월출역 ↗) */
            > .ribbonActionBtn {
              flex-shrink: 0;
              display: flex;
              align-items: center;
              gap: 0.125rem;
              height: 1.75rem;
              margin-left: auto;
              padding: 0 0.5rem 0 0.75rem;
              border: none;
              border-radius: 5rem;
              background-color: var(--tonal);
              color: var(--text-secondary);
              font-size: 0.8125rem;
              font-weight: 500;
              white-space: nowrap;
              cursor: pointer;
              user-select: none;
              .material-symbols-rounded {
                font-size: 1rem;
                color: inherit;
              }
              &:hover {
                background-color: var(--tonal-deep);
                color: var(--selected-primary);
              }
            }
          }
          .inputCalendar {
            display: flex;
            gap: 0.25rem;
            align-items: center;
            flex-wrap: wrap;
            color: var(--text-secondary);

            > span:first-child {
              font-size: 0.875rem;
              margin: 0 0.5rem;
            }

            .date-picker-wrap {
              background-color: var(--tonal);
              border-top-left-radius: 0.25rem;
              border-bottom-left-radius: 0.25rem;

              &:focus-within {
                background-color: var(--tonal-deep);

                > input {
                  background-color: var(--tonal-deep);
                }
              }
            }

            input {
              height: 2.5rem;
              width: 6rem;
              padding: 0;
              text-align: center;
              outline: none;
            }

            button.date-picker-btn {
              width: 2.5rem;
              height: 2.5rem;
              padding: 0;
              border-left: 1px solid var(--outline);
              background-color: var(--tonal);
              border-radius: 0;
              border-top-right-radius: 0.25rem;
              border-bottom-right-radius: 0.25rem;

              > span {
                font-size: 16px;
                color: var(--text-primary);
              }

              &:hover:not(:disabled),
              &:focus:not(:disabled) {
                background-color: var(--tonal-deep);
              }

              &:disabled {
                cursor: default;
                > span {
                  color: var(--text-disabled);
                }
              }
            }
            button {
              height: 2.5rem;
              /* width: 3rem; */
              font-size: 0.875rem;
            }
            /* button.searchBtn {
              font-size: 0.875rem;
              font-weight: 600;
              width: fit-content;
              padding: 0.75rem;
              padding-right: 0.25rem;
              gap: 0.5rem;
              box-shadow: none;
              border: 1px solid var(--outline);
              .shortcut-f9 {
                background-color: var(--tonal-light);
                color: var(--text-secondary);
                border-radius: 0.25rem;
                font-size: 0.75rem;
                letter-spacing: 0;
                width: 1.75rem;
                height: 1.75rem;
                letter-spacing: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid var(--outline-em);
                font-weight: 600;
              }
            } */
          }

          .namespaceEllipsis {
            max-width: 26rem;
            text-overflow: ellipsis;
            overflow: hidden;
            display: block;
            white-space: nowrap;
          }
        }
        .table_wrap {
          overflow: auto;
          height: 100%;
        }
        .thead {
          position: sticky;
          top: 0;
          /* width: fit-content; */
        }
        .tbody {
          /* width: fit-content; */
        }
        .thead.eduList,
        .tbody.eduList {
          width: 100%;
        }
      }
      .tr {
        button {
          width: 3rem;
          padding: 0 0.5rem;

          font-size: 0.875rem;
        }
        /* span {
          font-size: 0.875rem;
        } */
        > div {
          flex-shrink: 0;
          > div {
            width: 100%;
            padding: 0 0.125rem;
            li {
              width: 100%;
              max-width: 100%;
              padding-left: 0.5rem;
            }
            span {
              width: 100%;
            }
          }
        }
        .datePickerWrapper {
          > div {
            width: fit-content;
            padding: 0;
          }
          .react-datepicker__input-container {
            display: flex;
            justify-content: center;
          }
          input {
            height: 2rem;
            width: 6rem;
            padding: 0;
            font-size: 0.875rem;
            text-align: center;
          }
        }

        @media screen and (max-width: 767px) {
          &.mobileAttendHeaderRow,
          &.mobileAttendBodyRow {
            justify-content: space-between;
          }

          &.mobileAttendHeaderRow {
            > div.mobileAttendPhotoCell {
              width: 4rem;
              min-width: 4rem;
              height: 2.5rem;
              min-height: 2.5rem;
              padding: 0 0.25rem;
            }

            > div.mobileAttendInoutCell {
              width: 3rem;
              min-width: 3rem;
              height: 2.5rem;
              min-height: 2.5rem;
              padding: 0 0.25rem;
            }

            > div.mobileAttendTimeCell {
              width: 14.5rem;
              min-width: 0;
              height: 2.5rem;
              min-height: 2.5rem;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              padding: 0 0.25rem;
            }
          }

          > div.mobileAttendPhotoCell {
            width: 4rem;
            min-width: 4rem;
            height: auto;
            min-height: 2.5rem;
          }

          > div.mobileAttendInoutCell {
            width: 3rem;
            min-width: 3rem;
            height: auto;
            min-height: 2.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-size: 0.875rem;
            color: var(--text-secondary);
          }

          > div.mobileAttendTimeCell {
            display: flex;
            width: 14.5rem;
            min-width: 0;
            height: auto;
            min-height: 2.5rem;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 0.25rem;
            padding: 0.125rem 0.25rem;
          }

          .mobileAttendTimeCell {
            .mobileAttendDateRow {
              display: flex;
              align-items: center;
              flex: 0 0 5.5rem;
              width: 5.5rem;
              max-width: 5.5rem;
              overflow: hidden;

              > div {
                width: 5.5rem;
                max-width: 5.5rem;
              }

              .react-datepicker-wrapper,
              .react-datepicker__input-container,
              input.inputMask {
                width: 5.5rem !important;
                max-width: 5.5rem;
              }

              input {
                height: 1.5rem;
                font-size: 0.75rem;
              }
            }

            .mobileAttendTimeRow {
              flex: 0 0 auto;
              width: fit-content;
              margin: 0;
              justify-content: flex-start;
              gap: 0.125rem;

              .reactSelectWrapper {
                width: 2.5rem;
                flex: 0 0 2.5rem;
                height: 1.75rem;
                align-items: center;

                > div {
                  width: 100%;
                  height: 1.75rem;
                }

                .basic-single > div {
                  width: 100%;
                  min-width: 0;
                }

                .basic-single > :nth-child(3) {
                  height: 1.75rem;
                  min-height: 1.75rem;
                  min-width: 0;
                  align-items: center;
                  overflow: hidden;

                  > div:first-child {
                    height: 1.75rem;
                    width: 1.75rem;
                    min-width: 1.75rem;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    > div {
                      width: 100%;
                      text-align: center;
                    }
                  }

                  > div:nth-child(2) {
                    width: 0.75rem;
                    min-width: 0.75rem;
                    flex: 0 0 0.75rem;
                    padding: 0;
                    justify-content: center;

                    > div {
                      padding: 0;
                    }

                    svg {
                      width: 0.75rem;
                      height: 0.75rem;
                    }
                  }
                }

                .select__value-container {
                  position: relative !important;
                  height: 1.75rem;
                  padding: 0 !important;
                  overflow: visible !important;
                }

                .select__single-value {
                  position: absolute !important;
                  top: 0 !important;
                  right: 0 !important;
                  bottom: 0 !important;
                  left: 0 !important;
                  transform: none !important;
                  display: flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  max-width: 100% !important;
                  overflow: visible !important;
                  font-size: 0.75rem;
                  margin: 0 !important;
                  white-space: nowrap;
                }
              }

              span {
                width: fit-content;
                flex: 0 0 auto;
                padding: 0 !important;
                text-align: center;
                font-size: 0.75rem;
              }
            }
          }
        }
      }
    }
    .modal-footer {
      border-top: 1px solid var(--outline);
      padding: 0.5rem;
      > div {
        gap: 0.25rem;
        > button {
          height: 2.5rem;
          font-size: 0.875rem;
          width: 6rem;
          padding: 0;
          @media screen and (max-width: 767px) {
            width: fit-content;
            padding: 0 1.5rem;
          }
        }
      }
      > .arrows {
        button {
          gap: 0.25rem;
          width: fit-content;
          gap: 0.5rem;
          background-color: #e5f1ff;
          background-color: var(--tonal);
          &:hover {
            background-color: var(--tonal-deep);
          }
          &:nth-child(1) {
            padding-left: 0.25rem;
            padding-right: 0.5rem;
            @media screen and (max-width: 767px) {
              padding-right: 1rem;
            }
            > div:nth-child(3) {
              padding-left: 0.5rem;
              border-left: 1px solid var(--outline);
              @media screen and (max-width: 767px) {
                display: none;
              }
              p {
                text-align: left;
              }
            }
          }
          &:nth-child(2) {
            padding-left: 0.5rem;
            padding-right: 0.25rem;
            @media screen and (max-width: 767px) {
              padding-left: 1rem;
            }
            > div:nth-child(1) {
              padding-right: 0.5rem;
              border-right: 1px solid var(--outline);
              @media screen and (max-width: 767px) {
                display: none;
              }
              p {
                text-align: right;
              }
            }
          }
          > p,
          > span {
            color: var(--selected-primary);
          }
          > div {
            p {
              color: var(--text-tertiary);
              font-size: 0.625rem;
              line-height: 1.125;
              letter-spacing: 0.025rem;
              font-weight: 600;
            }
          }
        }
      }
    }
    .control {
      .selectWrapper {
        width: 100%;
        > div {
          width: inherit;
        }
      }
      .reactSelectWrapper {
        width: 100%;
        > div {
          width: inherit;
        }
      }
      .addressWrapper {
        > div {
          display: flex;
          width: 100%;

          > :first-child {
            > div {
              order: 2;
            }
            > button {
              order: 1;
              margin: 0 1rem 0 0 !important;
            }
          }

          > :nth-child(2),
          > :nth-child(3) {
            padding-left: 1rem;
            width: 40%;
          }
        }
      }

      .bloodPressureWrapper {
        > div > div {
          width: 6rem;
        }
        span {
          padding: 0 1rem;
        }
      }

      .serialCheckbox {
        > :last-child {
          margin-right: 0;
        }

        > div > div {
          margin-right: 1rem;
          > label {
            margin: 0 0.5rem 0 0;
            font-size: 100%;
          }
        }

        .wSafetydeviceetc {
          * {
            margin-right: 0;
          }
          > div {
            > div {
              label {
                margin-right: 0.5rem;
              }
              display: flex;
            }
          }
        }

        input {
          margin-right: 0.5rem;
        }
      }

      .serialInputSelectWrapper {
        > div {
          display: flex;
          align-items: center;

          > div {
            width: 33.3%;
            display: flex;
            margin-right: 1rem;

            label {
              margin: 0 1rem 0 0;
            }
            > div {
              display: flex;
              width: 100%;
              > div {
                width: inherit;
              }
            }
          }
        }
      }

      .userImageWrapper {
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-height: 12rem;
        max-width: 18rem;
        justify-content: flex-end;
        overflow: hidden;
        color: var(--text-secondary);
        label {
          width: fit-content;
          margin: 1rem 0 0 0;
          justify-content: center;
          > div {
            line-height: 2;
            padding: 0 1rem;
            border-radius: 5px;
          }
        }

        img {
          max-height: 9rem;
        }

        .smallBtn {
          cursor: pointer;
          color: #eaeaea;
          background-color: #8950fc;
          border: 1px solid #8950fc;
          &:hover {
            color: #eaeaea;
            background-color: rgba(137, 80, 252, 0.6);
          }
        }
      }

      > div > div {
        display: flex;

        > label {
          margin: 0;
          // padding: 0 0.75rem;
          /* min-width: 7rem; */
          /* font-weight: bold; */
        }
      }
    }

    .view {
      input {
        background-color: transparent;
        border: none;
      }
      .selectWrapper ul {
        border: none;

        li {
          background-color: transparent;
          cursor: default;
          > span {
            display: none;
          }
        }
      }

      .serialInputSelectWrapper {
        ul {
          border: none;

          li {
            background-color: transparent;
            > span {
              display: none;
            }
          }
        }
      }
      button {
        display: none;
      }
      .datePickerWrapper {
        > :nth-child(3) > :nth-child(2) {
          display: none;
        }
        .applyBorder {
          border: 1px solid red;
        }
      }
    }
  }
  .modalHeaderTitle {
    font-weight: 500;
    height: 2.5rem;
    display: flex;
    align-items: center;
    padding: 0 0.5rem;
    gap: 1rem;
    color: var(--text-primary);
  }
  .innerTabChip {
    overflow: overlay;
    background-color: var(--tonal);
    border-radius: 5rem;
    &::-webkit-scrollbar {
      height: 0rem;
    }
    .tab {
      flex-shrink: 0;
      padding: 0 1.5rem;
      height: 2.5rem;
      display: flex;
      border-radius: 5rem;
      align-items: center;
      cursor: pointer;
      user-select: none;
      color: var(--text-secondary);
    }
    .tab:hover {
      /* background-color: rgba(0, 0, 0, 0.05); */
    }
    .activeTab {
      font-weight: var(--font-bold);
      color: var(--selected-primary);
      background-color: var(--tonal-deep);
      pointer-events: none;
    }
    /* .activeTab: */
  }
  .innerTab {
    /* padding-bottom: 2rem; */
    .tab {
      padding: 0 1rem;
      cursor: pointer;
      height: 3rem;
    }

    .activeTab {
      font-weight: bold;
      border-bottom: 2px solid rgb(63, 66, 84);
    }
  }

  > .modal-scrollStyle {
    padding: 30px 12px 30px 30px;

    > .inputForm-body {
      margin-right: 12px;

      > .modal-contents {
        padding-right: 12px;
      }
    }
  }
  .flexColumn {
    display: flex;
    flex-direction: column;
    padding: 0.5rem 0 1rem 0;
    > small {
      line-height: 1.5;
    }
  }

  .dpNone {
    display: none;
  }

  .subModal {
    max-width: none;

    .inputForm-body {
      > :first-child {
        width: 100%;
        > :first-child {
          width: 100%;

          > div {
            flex: 0.5;
            > div {
              width: 100% !important;
            }
          }

          > :last-child > div {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }

  .w100 {
    width: 100%;
    > div {
      padding-left: 1rem;
    }
  }
  .w30 {
    width: 30%;
    > div {
      width: 100%;
      padding-left: 1rem;
    }
  }
  .w25 {
    width: 25%;
    > div {
      width: 100%;
      padding-left: 0.5rem;
    }
  }
  .w10 {
    width: 10%;
  }
  .tableTop {
    padding: 0.5rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    > .flex-basic {
      gap: 0.5rem;
      flex-wrap: wrap;
      .flex-basic {
        label {
          font-size: 0.875rem;
        }
      }
      .flex-basic:nth-last-child(n + 2) > div > div > ul > li {
        max-width: 12rem;
        width: 8rem;
        span {
          width: 100%;
        }
      }
      .flex-basic:nth-child(4) {
        /* .flex-basic:last-child { */
        position: relative;
        margin: 0;
        input {
          width: 3.5rem;
          height: 2.5rem;
          border-radius: 0.25rem;
          padding: 0;
          padding-right: 0.75rem;
          text-align: center;
          font-size: 0.875rem;
        }
        span {
          position: absolute;
          right: 0.5rem;
          font-size: 0.875rem;
          user-select: none;
          color: var(--text-tertiary);
        }
      }
      button {
        height: 2.5rem;
        font-size: 0.875rem;
        padding: 0 1rem;
        font-weight: 300;
      }
      button:last-child {
        justify-items: end;
        font-weight: var(--font-medium);
      }
    }
    .buttonsWrapper {
      display: flex;
      gap: 0.5rem;
      button {
        height: 2.5rem;
        font-size: 0.875rem;
        padding: 0 1rem;
        font-weight: 300;
      }
    }
  }
  .checkedApply {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 0.25rem;
    align-items: center;
    height: 5rem;
    font-size: 0.875rem;
    background-color: #f7fbff;
    span {
      color: #0071e9;
    }
    button {
      margin: 0 0.5rem;
      width: fit-content;
      height: 2.25rem;
      padding: 0 0.75rem;
      font-size: 0.875rem;
      background-color: #e5f1ff;
      color: #0071e9;
      border: none;
      /* font-family: 'NanumBarunGothic'; */
      /* font-family: 'NanumBarunGothicBold'; */
      /* font-family: 'NanumBarunGothicLight'; */
    }
  }

  .mSiteCheck {
    flex-grow: 1;
    height: 2.5rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    background-color: var(--tonal);
    border-radius: 0.25rem;
    padding: 0 1rem;
    overflow-y: auto;

    label {
      user-select: none;
      width: fit-content;
      padding: 0;
      cursor: pointer;
    }

    .checkbox-item {
      height: 100%;
      label {
        &:hover {
          cursor: pointer;
        }
        width: fit-content;
        padding-right: 0 !important;
      }
      input {
        width: 1rem;
        height: 1rem;
        outline: none !important;
      }
    }
  }
  &.companyModal {
    .inputForm-body.attendList {
      @media screen and (max-width: 767px) {
        .tr {
          > div.mobileAttendPhotoCell {
            padding: 0.25rem 0.25rem;
          }

          > div.mobileAttendTimeCell {
            padding: 0.25rem 0.25rem;
            align-items: stretch;

            .mobileAttendDateRow,
            .mobileAttendTimeRow {
              align-items: center;
            }

            .mobileAttendDateRow {
              input {
                height: 2.5rem;
                font-size: 0.875rem;
              }
            }

            .mobileAttendTimeRow {
              .reactSelectWrapper {
                height: 2.5rem;

                > div {
                  height: 2.5rem;
                }

                .basic-single > :nth-child(3) {
                  height: 2.5rem;
                  min-height: 2.5rem;

                  > div:first-child {
                    height: 2.5rem;
                    width: 1.75rem;
                    min-width: 1.75rem;
                  }
                }

                .select__value-container {
                  height: 2.5rem;
                  font-size: 0.875rem;
                }

                .select__single-value {
                  line-height: 2.5rem;
                  font-size: 0.875rem;
                }
              }

              span {
                font-size: 0.875rem;
              }
            }
          }
        }
      }
    }
    .inputCalendar {
      @media (max-width: 767px) {
        width: 100%;
        flex-wrap: nowrap;

        > .flex-basic {
          width: 100%;
          min-width: 0;
        }

        .date-picker-wrap {
          flex: 1;
          min-width: 0;

          input {
            flex: 1;
            min-width: 0;
            width: 100%;
          }
        }

        button.date-picker-btn {
          flex: 0 0 2.5rem;
        }
      }
    }
    .modal-footer {
      @media screen and (max-width: 767px) {
        > div:not(.arrows) {
          > button {
            padding: 0 0.75rem;
            font-size: 0.75rem;
          }
        }
      }
      > .arrows {
        @media screen and (max-width: 767px) {
          button {
            width: 2.5rem;
            min-width: 2.5rem;
            padding: 0 !important;
            justify-content: center;
            gap: 0;
          }
        }
      }
    }
  }
`;
